import { useMemo } from "react";

import Timestamp from "components/Timestamp";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { ConfigElement } from "types/generated";
import { makeTimestampToCopy } from "ds/components/Table/helpers";

import useCellCopyAction from "../../useCellCopyAction";

const IntentProjectEnvironmentVariablesTableCreatedAtCell = ({
  item,
  ...cellProps
}: TableSimpleCellProps<ConfigElement>) => {
  const value = item.createdAt || 0;
  const copyAction = useCellCopyAction({
    text: makeTimestampToCopy(value),
  });

  const actions = useMemo(() => [copyAction], [copyAction]);

  return (
    <TableSimpleCell {...cellProps} actions={actions}>
      <Timestamp timestamp={value} />
    </TableSimpleCell>
  );
};

export default IntentProjectEnvironmentVariablesTableCreatedAtCell;
